import React from 'react';
import '../../App.css';

class ImageProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            alreadyLoaded: false,
        };
    }

    changeLoad = () => {
        if(this.state.alreadyLoaded)
            return
        this.setState({ loaded: true, alreadyLoaded: true})
    }

    render() {
        return (
            <div>
                <img
                    style={{ display: this.state.loaded ? "block" : 'none', objectFit:"cover", ...this.props.style }}
                    src={this.props.image }
                    onLoad={this.changeLoad}
                    alt="My Profile Avatar"
                />
            </div>
        );
    }
}

export default ImageProfile